import { TOfferDataRequirement } from '../../../../types';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
const BusinessPlan = ({ isOptional, isSubmitted, status }: TProps) => {
  return (
    <DocumentRequirement
      title="Business plan"
      documentType="business plan"
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <p>Include information on:</p>
        <ul>
          <li>The business you are proposing</li>
          <li>How you plan on generating revenue</li>
          <li>The size of investment you need</li>
          <li>How the funds will be used</li>
          <li>Details of your experience in the industry</li>
        </ul>
      </>
    </DocumentRequirement>
  );
};

export default BusinessPlan;
